import { sdkLogger } from '../../logger/logger';
import type { ApiResponse } from '../internalTypes';
import type { SdkLoggableError } from '../../types/shared';

export function logFetchStart(url: string): void {
  sdkLogger.info('Starting survey layout API fetch...', { url });
}

export function logFetchPerfFailure(durationMs: number, status: number | string, url: string): void {
  sdkLogger.perf({
    apiName: 'GET Survey Layout',
    durationMs,
    status,
    url,
    success: false,
  });
}

export function logFetchPerfSuccess(durationMs: number, status: number, url: string, payloadSize: string): void {
  sdkLogger.perf({
    apiName: 'GET Survey Layout',
    durationMs,
    status,
    url,
    payloadSize,
    success: true,
  });
}

export function logFetchSuccess(apiResponse: ApiResponse): void {
  sdkLogger.success('Raw survey layout fetched successfully', { apiResponse });
}

export function logFetchError(err: SdkLoggableError): void {
  sdkLogger.error('Failed to fetch raw survey layout', { err });
}
